export const LEGAL_VERSION = "2026-08-23.1";
export const PRIVACY_CONTACT_EMAIL = "privacy@callsect.com";
export const CONTROLLER_NAME = "Maurizio Ciocca";
export const CONTROLLER_ADDRESS = "Rotwandstraße 6, 81539 Munich, Germany";
